export default defineComponent({
  name: 'ItemLinkAxeptioModal',
  props: {
    title: String
  },
  setup: function setup() {
    var openAxeptioCookies = function openAxeptioCookies() {
      window.openAxeptioCookies();
    };
    return {
      openAxeptioCookies: openAxeptioCookies
    };
  }
});